import classNames from "classnames";
import style from "../../index.module.scss";
import { Button, Icon, InputNumber, message, Tooltip } from "antd";
import lodash from "lodash-es";
import React from "react";
import OverLengthColumn from "components/OverLengthColumn";
import {
    ColumnsItem,
    GradeItemObjProps,
    GradeItemProps,
    GradeShowType,
    PublishStatus,
    saveGrade
} from "service/score";
import { errorMessage, isTrue } from "service/service";
import { ResultMessage } from "components/ResultMessage";
import Style from "./index.module.scss";
interface renderColumnProps {
    text: GradeItemProps;
    record: Record<string, GradeItemProps>;
    index: number;
    item: ColumnsItem;
    dataSource: Record<string, GradeItemProps>[];
    onOpen: (data: Record<string, GradeItemProps>) => void;
    courseNo: string;
    courseSeq: string;
    status: PublishStatus | null; //成绩单发布状态obj
    updateData: () => void; //刷新列表
    setDataSource: (val: Record<string, GradeItemProps>[]) => void;
    ShowType: GradeShowType | null;
}
function isGradeItemObjProps(obj: any): obj is GradeItemObjProps {
    return obj?.hasOwnProperty("originalScore");
}
const renderColumn = ({
    text,
    ShowType,
    record,
    item,
    index,
    dataSource,
    onOpen,
    courseNo,
    courseSeq,
    status,
    updateData,
    setDataSource
}: renderColumnProps) => {
    function showText(text: GradeItemProps) {
        if (isGradeItemObjProps(text)) {
            let _r = null;
            switch (ShowType) {
                case GradeShowType.percentage:
                    _r = text.originalScore;
                    break;
                case GradeShowType.number:
                    _r = text.score;
                    break;
            }
            return _r;
        } else {
            return text;
        }
    }

    const newDataSource = lodash.cloneDeep(dataSource);
    const { dataIndex } = item;

    const EditingProhibited = () => {
        if (!isTrue(status?.hasPublished)) {
            return false;
        } else {
            return record.canEdit !== "true";
        }
    };

    async function onSave(
        data: Record<string, GradeItemProps>,
        dataIndex: string,
        value: string
    ) {
        const params = {
            courseNo: courseNo,
            courseSeq: courseSeq,
            studentNo: data.studentNo,
            studentName: data.studentName,
            gradeType: ShowType as string,
            [dataIndex]: value
        };
        try {
            await saveGrade(params);
            message.success("修改成功");
            updateData();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    if (["remark"].includes(dataIndex)) {
        return <OverLengthColumn value={text as string} width={240} />;
    }
    if (["totalGrade"].includes(dataIndex)) {
        return (
            <div
                className={classNames(
                    showText(text) !== record.finalGrade
                        ? style.lineThrough
                        : ""
                )}>
                {showText(text)}
                {Number(showText(text)) > 100 && (
                    <Tooltip title="总成绩已大于100分">
                        <Icon className={Style.tips} type="warning" />
                    </Tooltip>
                )}
            </div>
        );
    }

    if (item.isCustom === "0" || item.dataIndex === "other") {
        return (
            <>
                <InputNumber
                    disabled={isTrue(status?.hasPublished)}
                    precision={1}
                    value={Number(showText(text))}
                    onChange={e => {
                        const currentObj: Record<string, GradeItemProps> =
                            newDataSource[index];
                        const newDataColumn = {
                            ...currentObj,
                            [dataIndex]: e || 0
                        };
                        const filterData = newDataSource.map(item => {
                            if (item.no === newDataColumn.no) {
                                return newDataColumn;
                            }
                            return item;
                        });
                        setDataSource([...filterData]);
                    }}
                    className={style.inputNumber}
                    min={0}
                    onBlur={e => {
                        const newObj = newDataSource[index];
                        onSave(newObj, dataIndex, e.target.value);
                    }}
                />
            </>
        );
    }

    if (dataIndex === "finalGrade") {
        return (
            <Button
                disabled={EditingProhibited()}
                type="primary"
                ghost
                className={classNames(style.btn, {
                    [style.greyBtn]: EditingProhibited()
                })}
                onClick={() => onOpen(record)}>
                {showText(text)}
            </Button>
        );
    }

    return (
        <>
            <Tooltip
                title={
                    ["studentNo", "studentName"].includes(dataIndex)
                        ? showText(text)
                        : ""
                }>
                <div className={style.column}>{showText(text)}</div>
            </Tooltip>
        </>
    );
};

export default renderColumn;
